/**
 * BEE-5389: 콘텐츠 경고 카테고리 선택지.
 *
 * 베트남 시행규칙 05/2023/TT-BVHTTDL Điều 3 의 7가지 카테고리. 백엔드
 * common.models.CONTENT_WARNING_CHOICES(ucms-be) 및 mediaio ContentWarning 과 같은
 * 코드값을 쓴다. 한쪽만 고치면 앱에 라벨 없는 코드가 나가므로 함께 유지할 것.
 *
 * LG Channel VN 앱이 등급 배지 옆에 표시한다. 등급처럼 시즌에서 입력하고, 에피소드가
 * 비어 있으면 시즌 값을 쓴다.
 */
export type ContentWarningCode =
  | 'theme'
  | 'violence'
  | 'nudity'
  | 'drugs'
  | 'horror'
  | 'vulgar'
  | 'dangerous';

export interface ContentWarningOption {
  value: ContentWarningCode;
  label: string;
}

export const CONTENT_WARNING_OPTIONS: ContentWarningOption[] = [
  { value: 'theme', label: 'Theme and content (Chủ đề, nội dung)' },
  { value: 'violence', label: 'Violence (Bạo lực)' },
  { value: 'nudity', label: 'Nudity and sex (Khỏa thân, tình dục)' },
  { value: 'drugs', label: 'Drugs and stimulants (Ma túy, chất kích thích)' },
  { value: 'horror', label: 'Horror (Kinh dị)' },
  { value: 'vulgar', label: 'Coarse language (Ngôn ngữ thô tục)' },
  { value: 'dangerous', label: 'Dangerous and imitable acts (Nguy hiểm dễ bắt chước)' },
];
